module.exports = __webpack_public_path__ + "static/media/sign_in_english.f6412064.jpg";